export default "__VITE_ASSET__a5ee4fa5__"